const SDK_VERSION = "10.59.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
